import Box from "@mui/material/Box";
import List from "@mui/material/List";
import styled from "@mui/material/styles/styled";
import {FOOTER_HEIGHT, HEADER_HEIGHT} from "base/config/measurements";

const getGroupTitleStyle = level => {
    switch (level) {
        case 0:
            return {
                fontSize: "0.95rem",
                fontWeight: 700,
                // color: "#1a237e",
                pl: 0.4,
                py: 0.4,
                mb: 0.2,
                textTransform: "uppercase",
            };
        case 1:
            return {
                fontSize: "0.85rem",
                fontWeight: 600,
                // color: "#3949ab",
                pl: 0.2,
                py: 0.2,
                mb: 0.2,
                textTransform: "uppercase",
            };
        default:
            return {
                fontSize: "0.8rem",
                fontWeight: 500,
                //color: "#5c6bc0",
                pl: 0.1,
                py: 0.1,
                mb: 0.2,
                textTransform: "uppercase",
            };
    }
};

const MapMenuBox = styled(Box)(({theme}) => ({
    height: "100%",
    overflowY: "scroll",
    overflowX: "hidden",
    minWidth: "300px",
    backgroundColor: theme.palette.white,
    borderLeft: `1px solid ${theme.palette.primary.light}`,
    fontSize: "0.85rem",
    "& .MapMenuList": {
        widht: "100%",
        "& .LayerMenuListItem": {
            paddingTop: "2px",
            paddingBottom: "2px",
            "& .LayerMenuCheckbox": {
                transform: "scale(0.7)",
                padding: "0px",
            },
            "& .LayerMenuIcon": {
                width: "24px",
                height: "24px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "3px",
                marginRight: "3px",
                backgroundColor: "white",
                border: `1px solid ${theme.palette.secondary.light}`,
                borderRadius: "4px",
            },
            "& .MuiListItemSecondaryAction-root": {
                "& .MuiSvgIcon-root": {
                    transform: "scale(0.7)",
                },
            },
        },
        "& .LayerMenuDiscriminatorInfo": {
            marginLeft: "25px",
            marginRight: "30px",
            paddingTop: "0px",
            paddingBottom: "2px",
            color: "#555",
            backgroundColor: "white",
            border: `1px solid ${theme.palette.secondary.light}`,
            borderBottomLeftRadius: "4px",
            borderBottomRightRadius: "4px",
            "& .LayerMenuDiscriminatorInfoHeader": {
                lineHeight: "18px",
                fontWeight: "normal",
                fontStyle: "italic",
                fontSize: "0.75rem",
                color: "#555",
            },
            "& .LayerMenuLegendItem": {
                height: "20px",
                paddingLeft: "8px",
                fontSize: "0.75rem",
                "& .LayerMenuLegendItemButton": {
                    transform: "scale(0.7)",
                    color: "#aaa",
                    padding: "0px",
                },
                "& .LayerMenuLegendItemIcon": {
                    width: "20px",
                    display: "flex",
                    justifyContent: "center",
                    transform: "scale(0.6)",
                },
                "& .LayerMenuLegendItemText": {
                    "& .MuiTypography-root": {
                        fontSize: "0.7rem",
                    },
                },
            },
        },
    },
}));

const MapMenu = ({children}) => {
    return (
        <MapMenuBox>
            <List className="MapMenuList">{children}</List>
        </MapMenuBox>
    );
};

export {getGroupTitleStyle};
export default MapMenu;
